import React from "react";
import { useTheme } from "arkh";
import { Login } from "./Login/Login";
import { StatusBar } from "expo-status-bar";
import { useAuthState } from "./Login/State";
import { UserLoggedIn } from "../TopLevelNavigators/UserLoggedIn/UserLoggedIn";
import { View } from "react-native";
import { LoggedInProvider } from "./Provider";
import { useIsMobileOnWeb } from "./Login/useIsMobileOnWeb";
function LoginBranchC() {
  const [state] = useAuthState();
  const theme = useTheme();
  const isMobileOnWeb = useIsMobileOnWeb();
  const key =
    state.currentAuthSessionIndex === undefined
      ? "default_key"
      : (state.authSessions[state.currentAuthSessionIndex]?.user?.sub ??
        "default_key");
  return (
    <View style={{ flex: 1, backgroundColor: theme.background }} key={key}>
      <StatusBar style="dark" />
      {isMobileOnWeb || state.currentAuthSessionIndex === undefined ? (
        <Login />
      ) : (
        <LoggedInProvider>
          <LoggedIn />
        </LoggedInProvider>
      )}
    </View>
  );
}

function LoggedIn() {
  return <UserLoggedIn />;
}
export const LoginBranch = React.memo(LoginBranchC);
